require('./components/authentication/axios-interceptor');

require('./components/Router');
